import React from 'react'

export default ({ children }) => children



// WEBPACK FOOTER //
// ./_template.jsx